import {
  GET_SINGLE_ORGANIZATION_OVERVIEW_ERROR,
  GET_SINGLE_ORGANIZATION_OVERVIEW_START,
  GET_SINGLE_ORGANIZATION_OVERVIEW_SUCCESS,
} from 'constants/action-types/organizations/singleOrganizationOverview';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_SINGLE_ORGANIZATION_OVERVIEW_START:
      return {
        ...state,
        singleOrganizationOverview: {
          ...state.singleOrganizationOverview,
          loading: true,
          error: null,
        },
      };
    case GET_SINGLE_ORGANIZATION_OVERVIEW_SUCCESS:
      return {
        ...state,
        singleOrganizationOverview: {
          ...state.singleOrganizationOverview,
          loading: false,
          data: payload.data,
        },
      };
    case GET_SINGLE_ORGANIZATION_OVERVIEW_ERROR:
      return {
        ...state,
        singleOrganizationOverview: {
          ...state.singleOrganizationOverview,
          loading: false,
          error: payload,
        },
      };
    default:
      return null;
  }
};
